import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/api";
import { ALTRO_TOOLS as TOOLS, METODI_PREFERIBILI } from "../lib/methods";
import { MethodHeart } from "../components/MethodHeart";

export default function ScopriAltro() {
  const [content, setContent] = useState(null);
  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 lg:px-8 py-16 sm:py-20" data-testid="scopri-altro-page">
      <div className="text-center mb-12">
        <p className="eyebrow">Arcana oltre le carte</p>
        <h1 className="font-display text-4xl sm:text-5xl text-amber-100 mt-3">Scopri altro</h1>
        <p className="text-purple-200/60 text-sm mt-4 max-w-xl mx-auto leading-relaxed">
          {content?.scopri_altro_intro || "Tutti gli strumenti di Arcana: i Tarocchi, le Napoletane, la Stesa 26, la Piacentine, l'Oracolo del Destino, le Rune, il tuo cielo quotidiano e la numerologia."}
        </p>
      </div>

      <div className="grid grid-cols-3 gap-4 sm:gap-6">
        {TOOLS.map((t) => (
          <Link
            key={t.testid}
            to={t.to}
            data-testid={t.testid}
            className="group text-center"
          >
            <div className="relative rounded-2xl overflow-hidden border border-amber-500/25 group-hover:border-amber-500/60 group-hover:shadow-[0_0_30px_rgba(212,175,55,0.22)] group-hover:-translate-y-1 transition-all duration-300">
              <img src={t.image} alt={t.title} className="w-full aspect-square object-cover" />
            </div>
            <div className="flex items-center justify-center gap-1.5 mt-3">
              <h3 className="font-display text-sm sm:text-lg text-amber-100 leading-tight">{t.title}</h3>
              {METODI_PREFERIBILI.includes(t.to.slice(1)) && (
                <MethodHeart metodo={t.to.slice(1)} testid={`${t.testid}-heart`} inline />
              )}
            </div>
          </Link>
        ))}
      </div>

      <div className="text-center mt-12">
        <Link to="/" data-testid="scopri-altro-back" className="inline-flex items-center gap-2 text-xs text-amber-300/80 hover:text-amber-200 transition-colors">
          <ArrowLeft className="w-3.5 h-3.5" /> Torna alle letture
        </Link>
      </div>
    </div>
  );
}
